import { generateTableSlice } from "./sliceTable";

const sliceUsersTable = generateTableSlice("Users");

export const ActionsUsersTable = sliceUsersTable.actions;
export const ReducerUsersTable = sliceUsersTable.reducer;
